import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import LoginScreen from './pages/login';
import DealershipManagement from './pages/dealership-management';
import TechnicianAssignment from './pages/technician-assignment';
import OrderManagementDashboard from './pages/order-management-dashboard';
import TechnicianMobileView from './pages/technician-mobile-view';
import VinScanner from './pages/vin-scanner';
import OrderDetailsPage from './pages/order-details';
import RevenueAnalyticsDashboard from './pages/revenue-analytics-dashboard';
import ServiceTypesManagement from './pages/service-types-management';
import AdministrativeDashboard from './pages/administrative-dashboard';
import AuditTrailReview from './pages/audit-trail-review';
import ClockSuccessConfirmation from './pages/clock-success-confirmation';
import EmployeeManagement from './pages/employee-management';
import KioskClockInterface from './pages/kiosk-clock-interface';
import ShiftPlanning from './pages/shift-planning';
import TimeEntryCorrections from './pages/time-entry-corrections';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Default route redirects to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginScreen />} />
        
        {/* Protected routes - require authentication */}
        {/* <Route path="/dealership-management" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <DealershipManagement />
          </ProtectedRoute>
        } />
        <Route path="/technician-assignment" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <TechnicianAssignment />
          </ProtectedRoute>
        } />
        <Route path="/order-management-dashboard" element={
          <ProtectedRoute>
            <OrderManagementDashboard />
          </ProtectedRoute>
        } />
        <Route path="/technician-mobile-view" element={
          <ProtectedRoute>
            <TechnicianMobileView />
          </ProtectedRoute>
        } />
        <Route path="/vin-scanner" element={
          <ProtectedRoute>
            <VinScanner />
          </ProtectedRoute>
        } />
        <Route path="/order-details" element={
          <ProtectedRoute>
            <OrderDetailsPage />
          </ProtectedRoute>
        } />
        <Route path="/revenue-analytics-dashboard" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <RevenueAnalyticsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/service-types-management" element={
          <ProtectedRoute requiredRoles={['admin']}>
            <ServiceTypesManagement />
          </ProtectedRoute>
        } /> */}
        
        {/* New Employee Management Routes */}
        <Route path="/administrative-dashboard" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <AdministrativeDashboard />
          </ProtectedRoute>
        } />
        {/* <Route path="/audit-trail-review" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <AuditTrailReview />
          </ProtectedRoute>
        } /> */}
        <Route path="/clock-success-confirmation" element={
          <ProtectedRoute>
            <ClockSuccessConfirmation />
          </ProtectedRoute>
        } />
        <Route path="/employee-management" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <EmployeeManagement />
          </ProtectedRoute>
        } />
        <Route path="/kiosk-clock-interface" element={
          <ProtectedRoute>
            <KioskClockInterface />
          </ProtectedRoute>
        } />
        <Route path="/shift-planning" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <ShiftPlanning />
          </ProtectedRoute>
        } />
        <Route path="/time-entry-corrections" element={
          <ProtectedRoute requiredRoles={['admin', 'dispatcher']}>
            <TimeEntryCorrections />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
